<template>
  <div>
    <MainHeader />

    <SubHeader v-bind:project="project" />
    <div
      class="container"
      v-if="loaded"
      style="background-color: #fff; padding-top: 15px; color: #666"
    >
      <div class="row" style="margin: 0px -5px">
        <div class="col-12" style="padding: 0px 5px">
          <h2>
            <i class="bi bi-archive-fill"></i> {{ project.name }} ({{
              factsheets.length
            }}
            Factsheets)
          </h2>

          <p v-html="project.description" />
        </div>
      </div>

      <!--<h2>Factsheets ({{factsheets.length}})</h2>-->
      <FactsheetCollection
        :factsheets="factsheets"
        :showFilters="showFilters"
      />
    </div>

    <Footer />
  </div>
</template>

<script>
import MainHeader from "@/components/generic/MainHeader.vue";
import SubHeader from "@/components/factsheet/SubHeader.vue";
import Footer from "@/components/generic/Footer.vue";
import FactsheetCollection from "@/components/home/FactsheetCollection.vue";
import Overview from "@/components/home/user/Overview.vue";

export default {
  name: "home",
  data() {
    return {
      loaded: false,
      project: null,
    };
  },
  mounted() {
    let apitoken = this.apitoken();
    let headers = {};
    if (apitoken != "") {
      headers = {
        Authorization: "Token " + this.apitoken(),
      };
    }

    this.$axios
      .get(
        process.env.VUE_APP_API +
          "/api/project/" +
          this.$route.params.project_slug +
          "/",
        { headers: headers, validateStatus: () => true }
      )
      .then((response) => {
        this.project = response.data;
        this.loaded = true;
      })
      .catch((error) => console.log(error));
  },
  components: {
    MainHeader,
    SubHeader,
    Footer,
    Overview,
    FactsheetCollection,
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    },
    init() {
      return this.$store.state.init;
    },
    factsheets() {
      return this.project.factsheets;
    },
    showFilters() {
      return this.factsheets.length > 9 ? true : false;
    },
    projectUrl() {
      return window.location.origin + this.$route.path;
    },
  },
};
</script>

<style scoped>
div.container {
  background-color: #eee;
}
h2 {
  font-size: 1.5em;
  font-weight: 600;
  color: #666;
}
ul.items {
  border: 0;
  margin: 0;
  padding: 0;
}
p {
  color: #666;
  font-size: 1.2em;
}
</style>
